import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

/**
 * MobileWarning component displays a warning message on mobile phones
 * preventing the application from being used on small screens.
 *
 * Matches the Figma design with:
 * - Vertical gradient background (light sage at top → darker sage at bottom)
 * - White text
 * - Centered layout
 * - Primary bold message and secondary regular message
 */
const MobileWarning: FC = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, #D7E1DB 0%, #BDCCBE 50%, #637A6F 100%)',
        padding: 3,
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 2,
          maxWidth: '90%',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: { xs: '24px', sm: '28px' },
            lineHeight: 1.3,
            letterSpacing: '-0.5px',
          }}
        >
          Moments works best on larger screens
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#FFFFFF',
            fontWeight: 400,
            fontSize: { xs: '16px', sm: '18px' },
            lineHeight: 1.5,
            opacity: 0.95,
          }}
        >
          Switch to a larger screen or expand this window
        </Typography>
      </Box>
    </Box>
  );
};

export default MobileWarning;
